import { a as __awaiter } from './tslib.es6-DN65qNZS.js';
import React, { forwardRef, useEffect, useImperativeHandle } from 'react';
import { useForm, FormProvider } from 'react-hook-form';

const Form = forwardRef(function InternalForm({ onSubmit, children, onStateChange }, ref) {
    const methods = useForm({ mode: "onTouched" });
    const { trigger, handleSubmit, formState: { isDirty, isValid, errors }, } = methods;
    useEffect(() => onStateChange && onStateChange({ isDirty, isValid }), [isDirty, isValid]);
    useImperativeHandle(ref, () => ({
        /**
         * The `trigger()` method can also accept an array
         * of fields to validate. We may at some point want
         * to consider adding a `validate()` method to the
         * `Form` component.
         */
        submit: () => __awaiter(this, void 0, void 0, function* () {
            const valid = yield trigger();
            if (valid) {
                submitHandler();
            }
            else {
                trigger();
                errorHandler(errors);
            }
        }),
    }));
    /**
     * If an onSubmit is not passed into a form, it will only be used
     * for validation. For that, we do not need to wrap it in a <form>
     * tag. This allows the <Form> component to be used in legacy code.
     */
    const Wrapper = onSubmit ? "form" : "div";
    const formProps = {
        onSubmit: onSubmit && handleSubmit(submitHandler, errorHandler),
    };
    return (React.createElement(FormProvider, Object.assign({}, methods),
        React.createElement(Wrapper, Object.assign({}, formProps, { "data-testid": "atlantis-form" }), children)));
    function submitHandler() {
        onSubmit && onSubmit();
    }
    function errorHandler(errs) {
        const firstErrName = Object.keys(errs)[0];
        const element = document.querySelector(`[name="${firstErrName}"]`);
        element === null || element === void 0 ? void 0 : element.focus();
    }
});

export { Form as F };
